var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z",
    stroke: "#DFDFEC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 10H10.66C9.56003 10 8.66003 10.9 8.66003 12V22H15.33V12C15.33 10.9 14.44 10 13.33 10Z",
    stroke: "#DFDFEC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17H15.33V22H22V19C22 17.9 21.1 17 20 17Z",
    stroke: "#DFDFEC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.52 2.07001L13.05 3.13C13.12 3.28 13.31 3.42 13.47 3.44L14.43 3.60001C15.04 3.70001 15.19 4.14999 14.75 4.57999L14 5.32999C13.87 5.45999 13.8 5.69999 13.84 5.86999L14.05 6.79001C14.22 7.52001 13.83 7.80001 13.19 7.42001L12.29 6.89001C12.13 6.79001 11.86 6.79001 11.7 6.89001L10.8 7.42001C10.16 7.80001 9.76998 7.52001 9.93998 6.79001L10.15 5.86999C10.19 5.69999 10.12 5.44999 9.98999 5.32999L9.24999 4.59C8.80999 4.15 8.94999 3.70998 9.56999 3.60998L10.53 3.45001C10.69 3.42001 10.88 3.28001 10.95 3.14001L11.48 2.07999C11.77 1.49999 12.23 1.50001 12.52 2.07001Z",
    stroke: "#DFDFEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.fc8d3244f7d02a8f9b03c50a665da4e1.svg";
export { ForwardRef as ReactComponent };